import { TootHeroBackgroundImage } from "../../../../modules/content/components/TootHeroBackgroundImage/TootHeroBackgroundImage";
import { TootHeroCentered } from "../../../../modules/content/components/TootHeroCentered/TootHeroCentered";
import { TootHeroSplitImage } from "../../../../modules/content/components/TootHeroSplitImage/TootHeroSplitImage";
import type { IHeroBlockProps } from "./HeroBlock.props";

export const HeroBlock = (props: IHeroBlockProps) => {
  const hasContent = Boolean(
    props.eyebrow || props.heading || props.subheading || props.buttons?.length || props.image,
  );

  if (!hasContent) {
    return null;
  }

  if (props.variant === "centered") {
    return <TootHeroCentered {...props} />;
  }

  if (props.variant === "split-image") {
    return <TootHeroSplitImage {...props} />;
  }

  if (props.variant === "background-image") {
    return <TootHeroBackgroundImage {...props} />;
  }

  return null;
};

HeroBlock.displayName = "Block::HeroBlock";
